/**
 * <ry-logo-bar>
 *
 * Logo bar / trust strip for landing pages (CSS-only layout).
 *
 * Default: centered row, wraps on small screens.
 * scroll: horizontal scroll, no wrap.
 * marquee: infinite auto-scrolling loop.
 *
 * Usage:
 * <ry-logo-bar>
 *   <p>Trusted by industry leaders</p>
 *   <span>Acme</span>
 *   <span>Globex</span>
 * </ry-logo-bar>
 *
 * <ry-logo-bar layout="scroll">...</ry-logo-bar>
 * <ry-logo-bar layout="marquee">...</ry-logo-bar>
 */

import { RyElement } from '../core/ry-element.js';

export class RyLogoBar extends RyElement {
  setup(): void {
    // Marquee: duplicate children for seamless loop
    if (this.getAttribute('layout') === 'marquee') {
      this.#setupMarquee();
    }
  }

  #setupMarquee(): void {
    // Wrap existing logo children (not <p>) in a track, then duplicate
    const heading = this.$('p');
    const logos = [...this.children].filter(c => c.tagName !== 'P');
    if (logos.length === 0) return;

    const track = document.createElement('div');
    track.setAttribute('data-ry-target', 'track');
    track.classList.add('ry-logo-bar__track');

    // Move originals into track
    logos.forEach(l => track.appendChild(l));

    // Clone 3x for seamless loop (4 sets total)
    for (let i = 0; i < 3; i++) {
      logos.forEach(l => {
        const clone = l.cloneNode(true) as HTMLElement;
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      });
    }

    // Re-append heading then track
    this.innerHTML = '';
    if (heading) this.appendChild(heading);
    this.appendChild(track);
  }
}

customElements.define('ry-logo-bar', RyLogoBar);
